<ul [ngClass]="{'flex' : flex, 'grid' : grid}" [ngStyle]="{'gap': gap !== undefined ? gap + 'px' : '',
                                            'padding': containerPadding !== undefined ? containerPadding + 'px' : '',
                                            'grid-template-columns': gridColumns ? 'repeat(' + gridColumns + ', 1fr)' : ''}">
  <li *ngFor="let i of Array(count).fill(1)" class="skeleton {{style}}">
    <ng-container *ngIf="style === 'folder-row'">
      <span class="sk-bone sk-icon"></span>
      <span class="sk-bone sk-label"></span>
      <span class="sk-bone sk-badge"></span>
    </ng-container>
  </li>
</ul>
